export const instructions = [
   'Откройте приложение MAX и перейдите в меню "Профиль"',
   'Перейдите в раздел "Устройства" и выберите "Войти по QR-коду"',
   'Наведите камеру на QR-код и отсканируйте его'
]
